import { zSchema } from "@zeal/common";
import {
  publicIDUploadLinkSchema,
  TIDUploadLinkResponse,
} from "../shared/idUploadTypes";

/**
 * Request schema for generating employee document upload links
 * Extends the shared public schema with employee-specific fields
 */
export const postGenerateEmployeeIDUploadLinkSchema =
  publicIDUploadLinkSchema.extend({
    employeeID: zSchema.string().min(1, "Employee ID is required"),
  });

export type TPostGenerateEmployeeIDUploadLinkRequest = zSchema.infer<
  typeof postGenerateEmployeeIDUploadLinkSchema
>;

export type TPostGenerateEmployeeIDUploadLinkResponse = TIDUploadLinkResponse;
